const rimac = {
    compañia: 'rimac',
    gama: {
        'basico': {
            'Rímac Red Preferente': {
                Titulares: {
                    0: 3345,
                    1: 3345,
                    2: 3345,
                    3: 3345,
                    4: 3345,
                    5: 3345,
                    6: 3345,
                    7: 3345,
                    8: 3345,
                    9: 3345,
                    10: 3345,
                    11: 3345,
                    12: 3345,
                    13: 3345,
                    14: 3345,
                    15: 3345,
                    16: 3345,
                    17: 3345,
                    18: 3345,
                    19: 3345,
                    20: 3345,
                    21: 3345,
                    22: 3345,
                    23: 3345,
                    24: 3345,
                    25: 3345,
                    26: 3473,
                    27: 3498,
                    28: 3523,
                    29: 3549,
                    30: 3642,
                    31: 3640,
                    32: 3666,
                    33: 3665,
                    34: 3732,
                    35: 3771,
                    36: 3851,
                    37: 3852,
                    38: 3905,
                    39: 3933,
                    40: 3986,
                    41: 4167,
                    42: 4295,
                    43: 4398,
                    44: 4489,
                    45: 4590,
                    46: 4779,
                    47: 5029,
                    48: 5240,
                    49: 5584,
                    50: 5877,
                    51: 6145,
                    52: 6628,
                    53: 6844,
                    54: 7119,
                    55: 7442,
                    56: 7941,
                    57: 8403,
                    58: 8814,
                    59: 9343,
                    60: 9590,
                    61: 10416,
                    62: 11509,
                    63: 12621,
                    64: 13782,
                    65: 14528,
                }
            },
        },
        'completo': {
            'Rímac Red Médica': {
                Titulares: {
                    0: 3881,
                    1: 3881,
                    2: 3881,
                    3: 3881,
                    4: 3881,
                    5: 3881,
                    6: 3881,
                    7: 3881,
                    8: 3881,
                    9: 3881,
                    10: 3881,
                    11: 3881,
                    12: 3881,
                    13: 3881,
                    14: 3881,
                    15: 3881,
                    16: 3881,
                    17: 3881,
                    18: 3881,
                    19: 3881,
                    20: 3881,
                    21: 3881,
                    22: 3881,
                    23: 3881,
                    24: 3881,
                    25: 3881,
                    26: 4298,
                    27: 4491,
                    28: 4625,
                    29: 4790,
                    30: 4815,
                    31: 4877,
                    32: 4902,
                    33: 4951,
                    34: 4976,
                    35: 5038,
                    36: 5049,
                    37: 5059,
                    38: 5069,
                    39: 5080,
                    40: 5128,
                    41: 5534,
                    42: 5928,
                    43: 6438,
                    44: 6662,
                    45: 6909,
                    46: 7403,
                    47: 7706,
                    48: 7950,
                    49: 7950,
                    50: 8205,
                    51: 8505,
                    52: 9062,
                    53: 9466,
                    54: 9775,
                    55: 10189,
                    56: 11081,
                    57: 11526,
                    58: 12050,
                    59: 12942,
                    60: 14154,
                    61: 14983,
                    62: 16477,
                    63: 17714,
                    64: 18947,
                    65: 20543,
                }
            },
        },
        'gamaAlta': {
            'Rímac Full Salud': {
                Titulares: {
                    0: 4911,
                    1: 4911,
                    2: 4911,
                    3: 4911,
                    4: 4911,
                    5: 4911,
                    6: 4911,
                    7: 4911,
                    8: 4911,
                    9: 4911,
                    10: 4911,
                    11: 4911,
                    12: 4911,
                    13: 4911,
                    14: 4911,
                    15: 4911,
                    16: 4911,
                    17: 4911,
                    18: 4911,
                    19: 4911,
                    20: 4911,
                    21: 4911,
                    22: 4911,
                    23: 4911,
                    24: 4911,
                    25: 4911,
                    26: 5291,
                    27: 5572,
                    28: 5837,
                    29: 6153,
                    30: 6505,
                    31: 6720,
                    32: 6983,
                    33: 7147,
                    34: 7287,
                    35: 7401,
                    36: 7490,
                    37: 7580,
                    38: 7730,
                    39: 7892,
                    40: 8227,
                    41: 8523,
                    42: 8929,
                    43: 9236,
                    44: 9567,
                    45: 9800,
                    46: 10313,
                    47: 10677,
                    48: 10945,
                    49: 11345,
                    50: 11830,
                    51: 12695,
                    52: 13623,
                    53: 14390,
                    54: 15082,
                    55: 15711,
                    56: 16206,
                    57: 17137,
                    58: 18079,
                    59: 19067,
                    60: 20248,
                    61: 21244,
                    62: 22445,
                    63: 23957,
                    64: 25841,
                    65: 27601,
                }
            },
        },
        'gamaSuperAlta': {
            'Rímac Red Preferencial': {
                Titulares: {
                    0: 9347,
                    1: 9347,
                    2: 9347,
                    3: 9347,
                    4: 9347,
                    5: 9347,
                    6: 9347,
                    7: 9347,
                    8: 9347,
                    9: 9347,
                    10: 9347,
                    11: 9347,
                    12: 9347,
                    13: 9347,
                    14: 9347,
                    15: 9347,
                    16: 9347,
                    17: 9347,
                    18: 9347,
                    19: 9347,
                    20: 9347,
                    21: 9347,
                    22: 9347,
                    23: 9347,
                    24: 9347,
                    25: 9347,
                    26: 10171,
                    27: 11213,
                    28: 12077,
                    29: 12607,
                    30: 12974,
                    31: 13123,
                    32: 13221,
                    33: 13307,
                    34: 13358,
                    35: 13493,
                    36: 13689,
                    37: 14027,
                    38: 14328,
                    39: 14557,
                    40: 14750,
                    41: 14918,
                    42: 14968,
                    43: 15114,
                    44: 15270,
                    45: 15320,
                    46: 15982,
                    47: 16747,
                    48: 17568,
                    49: 18421,
                    50: 19388,
                    51: 20271,
                    52: 20981,
                    53: 22887,
                    54: 24082,
                    55: 25704,
                    56: 26825,
                    57: 28224,
                    58: 29428,
                    59: 30741,
                    60: 32691,
                    61: 35958,
                    62: 38993,
                    63: 41471,
                    64: 45240,
                    65: 48305,
                }
            },
        }
    }
}
export default rimac